// extracted by mini-css-extract-plugin
export default {"bookings__tab":"Bookings_bookings__tab__R2P9S","active":"Bookings_active__T5cRH"};